import React from 'react';
import { componentService } from 'js/services/component.service';

export const BingoScheduler = React.lazy(() => import(/* webpackChunkName: "bingo-scheduler" */ './BingoScheduler'));

componentService.registerPageComponents({ bingoscheduler: BingoScheduler });
